module.exports = __webpack_public_path__ + "static/media/17.d9256a6e.jpg";